export default "__VITE_ASSET__434f0c6b__"